import { render, staticRenderFns } from "./PendingIssues.vue?vue&type=template&id=959e950a&scoped=true"
import script from "./PendingIssues.vue?vue&type=script&lang=js"
export * from "./PendingIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959e950a",
  null
  
)

export default component.exports